/*
 * Copyright (c) 2020 Via Transportation, Inc. All rights reserved.
 *
 * This software is distributed under license and may not be used, copied,
 * modified, or distributed without the express written permission of
 * Via Transportation, Inc.
 */

import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { AuthenticationState } from "common/types/authentication/AuthenticationState";

const initialState = {} as AuthenticationState;

export const authenticationSlice = createSlice({
    initialState,
    name: "authentication",
    reducers: {
        setAuthentication: (_, action: PayloadAction<AuthenticationState>) => action.payload,
    },
});

// Actions
export const { setAuthentication } = authenticationSlice.actions;

// Reducer
export default authenticationSlice.reducer;
